function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "ico_gnb_cart"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 410",
  style: {
    strokeLinejoin: "round",
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.609 0h13.916l2.609 15.421H0z",
  style: {
    stroke: "none"
  },
  transform: "translate(6.434 10.34)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.61 0 0 15.421h19.135L16.525 0zm0-1.3h13.916a1.3 1.3 0 0 1 1.282 1.083l2.61 15.421a1.3 1.3 0 0 1-1.282 1.517H0a1.3 1.3 0 0 1-1.282-1.517l2.61-15.42A1.3 1.3 0 0 1 2.609-1.3z",
  style: {
    fill: "#000",
    stroke: "none"
  },
  transform: "translate(6.434 10.34)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Subtraction 6",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M23653.975 19531h-8.945a5 5 0 0 1-.027-.5 4.5 4.5 0 0 1 9 0q-.001.253-.025.5z",
  style: {
    stroke: "none"
  },
  transform: "translate(-23633.566 -19520.66)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23652.6 19529.7a3.2 3.2 0 0 0-3.098-2.397 3.2 3.2 0 0 0-3.098 2.396h6.196m1.375 1.301h-8.946a4.506 4.506 0 0 1 4.473-4.998 4.506 4.506 0 0 1 4.475 4.996z",
  style: {
    fill: "#000",
    stroke: "none"
  },
  transform: "translate(-23633.566 -19520.66)"
}))));
export default SvgIconCart;